import {styled} from '@mui/material/styles'
import theme from '../../../themes'
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  FormControl,
  FilledInput,
  Typography,
  menuClasses,
  Paper
} from '@mui/material'

export const StyledAGPContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'containerHeight' && prop !== 'switchFilters'
})(({containerHeight, switchFilters, theme}) => ({
  color: theme.palette.common.grey2,
  padding: '15px',
  width: '100%',
  fontSize: theme.typography.heading.fontSize.xxs,
  height: `${containerHeight}`,
  maxHeight: `${containerHeight}`,
  overflowY: switchFilters ? 'auto' : 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative'
}))

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '10px'
}))

export const StyledContainer = styled('div')(() => ({
  paddingTop: '11px'
}))

export const StyledField = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center'
}))

export const StyledFieldContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSearchClicked' && prop !== 'defaultFilterText'
})(({isSearchClicked, defaultFilterText, theme}) => ({
  borderTop: defaultFilterText && `1.5px dashed ${theme.palette.common.grey2}`,
  padding: '15px 0px',
  minHeight: isSearchClicked ? '257px' : '393px'
}))

export const StyledTitleContainer = styled(Typography)(({theme}) => ({
  color: theme.palette.common.white,
  fontSize: theme.typography.heading.fontSize.xs,
  display: 'flex',
  justifyContent: 'space-between'
}))

export const StyledTitle = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.heading.fontWeight.bold
}))

export const StyledInterestTagTitleContainer = styled(StyledTitle)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: theme.typography.heading.fontSize.xl,
  textTransform: 'none',
  padding: '16px 0px 0px 0px'
}))

export const StyledSearchContainer = styled(Paper)(() => ({
  position: 'absolute',
  bottom: '5%',
  margin: '15px 0px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '90%',
  backgroundColor: 'transparent'
}))

export const StyledSearchBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'isSearchClicked'})(
  ({isSearchClicked}) => ({
    display: 'flex',
    marginTop: isSearchClicked ? '6px' : '0px'
  })
)

export const StyledSearch = styled(Box)(() => ({
  width: '90%'
}))

export const StyledFormControl = styled(FormControl)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: 'auto',
  flexDirection: 'row'
}))

export const StyledFilledInput = styled(FilledInput)(({theme}) => ({
  backgroundColor: theme.palette.blackShade,
  color: theme.palette.common.green,
  fontSize: theme.typography.heading.fontSize.xs,
  width: '100%',
  padding: '0px 8px 8px 12px',
  borderRadius: '5px',
  '& .MuiFilledInput-input': {
    paddingTop: '8px'
  },
  '&.Mui-focused': {
    backgroundColor: theme.palette.blackShade,
    color: theme.palette.greyShad
  },
  '& .Mui-disabled': {
    color: theme.palette.greyShade,
    opacity: '0.3'
  },
  '&:hover': {
    backgroundColor: theme.palette.blackShade,
    color: theme.palette.greyShad
  }
}))

export const StyledAddButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.white,
  fontWeight: theme.typography.heading.fontWeight.regular,
  whiteSpace: 'nowrap',
  minHeight: '29px',
  fontSize: theme.typography.heading.fontSize.xxs,
  margin: '0px 5px 0px 10px',
  padding: '0px 10px',
  border: `1px solid ${theme.palette.common.blue}`
}))

export const StyledSendButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.common.darkGrey,
  fontWeight: theme.typography.heading.fontWeight.regular,
  whiteSpace: 'nowrap',
  minHeight: '29px',
  fontSize: theme.typography.heading.fontSize.xxs,
  margin: '0px 0px 0px 10px',
  padding: '4px 4px',
  border: 'none',
  '&.Mui-disabled': {
    color: theme.palette.greyShade,
    opacity: '0.3'
  }
}))

export const StyledMenu = styled(Menu)(() => ({
  [`&.${menuClasses.root}`]: {
    width: '100%'
  },
  [`& .${menuClasses.list}`]: {
    padding: 0
  }
}))

export const StyledMenuItem = styled(MenuItem)(() => ({
  fontSize: theme.typography.heading.fontSize.xxs,
  padding: '0 10px',
  '&.Mui-disabled': {
    color: theme.palette.common.darkgrey
  }
}))

export const StyledCheckBox = styled(Checkbox)(({theme}) => ({
  color: theme.palette.common.white
}))

export const StyledLabel = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.heading.fontWeight.regular,
  fontSize: theme.typography.heading.fontSize.xxs,
  fontStyle: 'italic',
  width: '30%',
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '0 10px 0 35px',
  color: theme.palette.common.grey2,
  textTransform: 'none'
}))

export const StyledValueBox = styled(Box)(({theme}) => ({
  width: '70%'
}))

export const StyledActionButtons = styled(Box)(({theme}) => ({
  position: 'sticky',
  bottom: '-15px',
  right: '15px',
  minHeight: '45px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  backgroundColor: theme.palette.common.black,
  zIndex: 1000
}))

export const StyledClearButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.white,
  textTransform: 'none',
  margin: '0px 20px',
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledCreateSegmentedListButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.white,
  border: `1px solid ${theme.palette.common.blue}`,
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledSpan = styled('span', {shouldForwardProp: (prop) => prop !== 'defaultFilterText'})(
  ({theme, defaultFilterText}) => ({
    color: defaultFilterText ? theme.palette.common.white : theme.palette.common.grey2,
    fontSize: theme.typography.heading.fontSize.l
  })
)

export const StyledButton = styled(Button, {shouldForwardProp: (prop) => prop !== 'defaultFilterText'})(
  ({theme, applyMargin}) => ({
    fontSize: theme.typography.heading.fontSize.xxs,
    color: theme.palette.common.white,
    textTransform: 'none',
    border: `1px solid ${theme.palette.common.blue}`,
    borderRadius: '15px',
    marginTop: applyMargin && '10px'
  })
)

export const StyledActionResetButton = styled(Button)(({theme}) => ({
  border: `1px solid ${theme.palette.common.blue1}`,
  color: theme.palette.common.blue1,
  textTransform: 'none',
  marginRight: '18px',
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledActionAddButton = styled(Button)(({theme}) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  marginRight: '10px',
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.xs,
  '&:hover': {backgroundColor: theme.palette.primary.main}
}))

export const StyledSwitchButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.white,
  textTransform: 'none',
  fontSize: theme.typography.heading.fontSize.xs,
  fontWeight: theme.typography.heading.fontWeight.regular,
  float: 'right',
  border: `1px solid ${theme.palette.common.blue1}`,
  '&.Mui-disabled': {
    color: theme.palette.common.grey6,
    border: `1px solid ${theme.palette.common.blue1}`
  },
  '&:hover': {
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.blue1}`
  }
}))
